import { ArrowPathIcon } from "@heroicons/react/24/solid";
export default function Loader() {
    return (
        <div className="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 bg-white p-4 rounded-lg shadow-lg z-20">
            <ArrowPathIcon className="w-24 h-24 animate-spin text-indigo-600" />
        </div>
    );
}
